import HttpResponse from '@/store/models/httpResponse';

export default class HttpException {
  /** @type {HttpResponse|null} */
  response;
  /** @type {string|null} */
  message;

  constructor(error) {
    if (error instanceof HttpResponse) {
      this.response = error;
    } else {
      this.message = error?.message ?? String(error);
    }
  }
}
